import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import ja from './ja.json';
import ru from './ru.json';
import zh from './zh.json';
import zt from './zt.json';
import ko from './ko.json';

export default {
  de,
  en,
  es,
  fr,
  ja,
  ru,
  zh,
  zt,
  ko
};
